// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wrcSN","card":"styles_card__0IWME"};